import React, {useEffect, useState} from 'react'
import {Button, Modal} from 'react-bootstrap'
import {KTIcon} from '../../../_metronic/helpers'
import {useFormik} from 'formik'
import {
  ModeleReferentielFournisseurPOT,
  modeleReferentielFournisseurPOTInitValues,
} from '../../../components/Models'
import * as Yup from 'yup'
import FournisseurPOTFields from './components/FournisseurPOTFileds'
import {createFournisseurPOT} from '../../../components/requests'

const fournisseurPOTSchema = Yup.object().shape({
  nom: Yup.string().required('Le nom du fournisseur est requis'),
  lien: Yup.string().notRequired(),
})

const AddFournisseurPOTModal = ({
  show,
  showModal,
  setOptionFournisseur,
  onClose,
  pcs,
  setPieces,
  optionFournisseur,
}) => {
  const [loading, setLoading] = useState(false)
  const [nom, setNom] = useState('')
  const [existName, setExistName] = useState(false)
  const [isRequis, setIsRequis] = useState(false)
  const [verifEnCours, setVerifEnCours] = useState(false)

  const submitForm = async (
    fieldsToUpdate: Partial<ModeleReferentielFournisseurPOT>,
    callback: () => void
  ): Promise<void> => {
    const updatedData = Object.assign(
      {...modeleReferentielFournisseurPOTInitValues},
      fieldsToUpdate
    )

    try {
      const fournisseurPOTRequest = await createFournisseurPOT(updatedData)
      if (fournisseurPOTRequest?.status === 200 && fournisseurPOTRequest?.data?.id !== undefined) {
        // Mise à jour de la liste des options pour les fournisseurs
        const newOption = {
          value: fournisseurPOTRequest.data.id,
          label: fournisseurPOTRequest.data.nom,
        }

        setOptionFournisseur((prev) => [...prev, newOption])
        setPieces((prev) => ({
          ...prev,
          fournisseur: newOption.value,
        }))
        setExistName(false)
        showModal(false)
        onClose?.(pcs) // Rouvre le modalPOT
      } else if (fournisseurPOTRequest?.data?.message === 'Nom déjà existant') {
        setExistName(true)
      }
    } catch (ex) {
      console.error('Erreur lors de la création du fournisseur POT', ex)
    } finally {
      callback()
    }
  }

  const formik = useFormik<ModeleReferentielFournisseurPOT>({
    initialValues: modeleReferentielFournisseurPOTInitValues,
    validationSchema: fournisseurPOTSchema,
    onSubmit: async (values) => {
      setLoading(true)
      await submitForm(values, () => {
        setLoading(false)
        setVerifEnCours(false);
        setIsRequis(false)
      })
    },
  })


  useEffect(() => {

    // Si le champ est vide, inutile de faire une requête
    if (!nom.trim()) {
      setExistName(false);
      setVerifEnCours(false);
      setIsRequis(true)
      return;
    }else{
      setIsRequis(false)
    }

    setVerifEnCours(true);

    // Debounce : attendre 500 ms après la dernière frappe
    const timeoutId = setTimeout(async () => {
      try {
        const existe = optionFournisseur.find(
            (item) => item.label.toLowerCase() === nom.trim().toLowerCase()
        )

        if (existe) {
          setExistName(true)
          setVerifEnCours(false)
        } else {
          setExistName(false)
          setVerifEnCours(false)
        }
      } catch (error) {
        console.error('Erreur lors de la vérification du fournisseur', error);
      } finally {
        setVerifEnCours(false)
      }
    }, 500);

    return () => {
      clearTimeout(timeoutId); // on annule le timeout précédent après 500ms
    }

  }, [nom])

  const handleExistName = () => {
    setExistName(false)
  }

  return (
    <>
      <Modal
        size='lg'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        show={show}
        onHide={() => {
          showModal(false)
          onClose?.(pcs)
        }}
        backdrop={true}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Création d'un fournisseur POT</h5>
            <div
              className='btn btn-icon btn-sm btn-light-primary ms-2'
              onClick={() => {
                setExistName(false)
                setVerifEnCours(false)
                setIsRequis(false)
                showModal(false)
                onClose?.(pcs)
              }}
            >
              <KTIcon className='fs-2' iconName='cross' />
            </div>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className='modal-body pt-3'>
              <FournisseurPOTFields formik={formik} isInModal={true} nom={nom} setNom={setNom} existName={existName} verifEnCours={verifEnCours} isRequis={isRequis} onExistName={handleExistName}/>
            </div>
            <div className='modal-footer d-flex gap-4 justify-content-end'>
              <Button className='btn btn-primary' type='submit' disabled={loading || existName}>
                {loading ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Annulation en cours...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  'Confirmer'
                )}
              </Button>

              <Button
                variant='secondary'
                onClick={() => {
                  setExistName(false);
                  setVerifEnCours(false);
                  setIsRequis(false)
                  showModal(false)
                  onClose?.(pcs)
                }}
                disabled={loading}
              >
                Annuler
              </Button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  )
}

export {AddFournisseurPOTModal}
